import React from 'react';
import { coreCatalogStats } from '../api';
import { formatNumber } from '../lib';
import { StatItem } from './statItem';

export const Vacancies = () => {
  const { data, isLoading } = coreCatalogStats.endpoints.getVacanciesStats.useQuery();
  return <StatItem isLoading={isLoading} label="Вакансии" value={formatNumber(data?.active.totalCount)} />;
};
